import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { createBedType } from "../api/bedMasterApi";

/**
 * Add New Ward — the form half of the Ward Management screen, laid out like
 * FacilityUsers / DoctorsAddition (bootstrap form-control + react-hook-form).
 *
 * A ward carries the daily charge that gets copied onto each billing bed when a
 * bed of this ward is created.
 *
 * The UI calls these wards; the backend entity is still a bed type
 * (ipd_bedtype/), so the API and prop names keep that wording.
 */
function BedTypeAddition({ updateList }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { is_active: true } });

  const onSubmit = async (data, e) => {
    e.preventDefault();

    const post_data = {
      name: data.name.trim(),
      code: data.code.trim(),
      // Sent as a decimal string — that is what the endpoint documents.
      daily_charge: Number(data.daily_charge).toFixed(2),
      description: data.description?.trim() || "",
      is_active: !!data.is_active,
    };

    try {
      const res = await createBedType(post_data);
      if (res?.status === "Success") {
        toast.success(res?.message || "Ward Created Successfully!");
        reset({ is_active: true });
        updateList();
      } else {
        toast.error(res?.message || "Could not create ward");
      }
    } catch (err) {
      console.error("createBedType:", err);
      toast.error(err?.response?.data?.message || "Could not create ward");
    }
  };

  return (
    <div>
      <div className="col-sm-12 col-md-12 col-lg-10" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50" style={{ marginTop: "50px" }}>
          <h4 style={{ textAlign: "center" }}>Add New Ward</h4>
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="name" className="required-label">
                  Ward Name{" "}
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Ward Name"
                    name="name"
                    {...register("name", {
                      required: "Ward Name is required.",
                    })}
                  />
                  {errors.name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.name.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="code" className="required-label">
                  Ward Code{" "}
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Ward Code (e.g. DLX)"
                    name="code"
                    {...register("code", {
                      required: "Ward Code is required.",
                    })}
                  />
                  {errors.code && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.code.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="daily_charge" className="required-label">
                  Daily Charge{" "}
                </label>
                <div className="form-group">
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    className="form-control"
                    placeholder="Enter Daily Charge"
                    name="daily_charge"
                    {...register("daily_charge", {
                      required: "Daily Charge is required.",
                      min: { value: 0, message: "Daily Charge cannot be negative." },
                    })}
                  />
                  {errors.daily_charge && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.daily_charge.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="description">Description </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Description"
                    name="description"
                    {...register("description")}
                  />
                </div>
              </div>

              <div
                className="col-sm-3 col-md-3 col-lg-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "3%",
                }}
              >
                <div className="form-group">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="is_active"
                      {...register("is_active")}
                    />
                    <label className="form-check-label" htmlFor="is_active">
                      Active
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-12 d-flex" style={{ padding: "0px" }}>
                <div className="col-6">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      backgroundColor: "#0E3F66",
                      color: "#FFFFFF",
                      borderRadius: "10px",
                      padding: "24px 140px",
                      gap: "10px",
                    }}
                  >
                    <span>Add Ward</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BedTypeAddition;
